import React from 'react';
import './AboutUs.css';

function AboutUsEn() {
  return (
    <section 
      className="about-us" 
      id="about-us"
      style={{
        backgroundImage: `url(${process.env.PUBLIC_URL}/grupo-bg.jpg)`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        backgroundColor: '#1a1a1a'
      }}
    >
      <div className="about-us-overlay"></div>
      <div className="container">
        <div className="about-content">
          <div className="about-text">
            <h1 className="about-title">Group</h1>
          </div>
        </div>
      </div>
    </section>
  );
}

export default AboutUsEn;
